type LoadingProps = {
  state: {
    loading: boolean
    size?: 4 | 6 | 8 | 10 | 12
    borderSize?: 2 | 4 | 6
  }
} & React.HTMLAttributes<HTMLDivElement>;

const Loading = ({ state: { loading, size = 12, borderSize = 4 }, ...restProps }: LoadingProps) => {
  if (!loading) return null;

  const sizeClass = {
    4: "w-4 h-4",
    6: "w-6 h-6",
    8: "w-8 h-8",
    10: "w-10 h-10",
    12: "w-12 h-12",
  }[size] ?? "w-12 h-12";

  const borderClass = {
    2: "border-2",
    4: "border-4",
    6: "border-6",
  }[borderSize] ?? "border-4";

  return (
    <div
      className="flex items-center justify-center"
      {...restProps}
    >
      <div className={`rounded-full animate-spin ${sizeClass} ${borderClass} border-blue-500 border-t-transparent`} />
    </div>
  );
};

export default Loading;
